import styled from 'styled-components';

export const Info = styled.p`
  font-size: 18px;
  margin: 0 0 16px;
`;
